export default {
	methods: {
		getCoordTop(elem) {
			return (elem ? elem.getBoundingClientRect().top : 0) + scrollY;
		}
	},
};
